import { Text, Title, Section as BaseSection } from '../../utils/theme';
import styled from 'styled-components';

export const Section = styled(BaseSection)`
  min-height: 0vh;
  position: relative;
  overflow: hidden;
  height: 140vw;

  @media (min-width: 600 && max-width: 1050px) {
    height: 70vw;
  }

  @media (max-width: 600px) {
    height: 500vw;
  }
`;

export const TracksTitle = styled(Title)`
  position: absolute;
  left: 50%;
  top: 0vw;
  transform: translateX(-50%);
  font-size: 3vw;
  text-align: center;

  @media (max-width: 600px) {
    left: 50%;
    top: 5vw;
    transform: translateX(-50%);
    width: 80vw;
    font-size: 6.5vw;
  }
`;

export const TracksText = styled(Text)`
  position: absolute;
  left: 50%;
  top: 4vw;
  transform: translateX(-50%);
  font-size: 1.5vw;
  text-align: center;
  white-space: nowrap; 
  overflow: hidden;    
  text-overflow: ellipsis;

  @media (max-width: 600px) {
    left: 50%;
    top: 20vw;
    transform: translateX(-50%);
    width: 80vw;
    font-size: 3vw;
    white-space: normal
  }
`;

export const TrackImageContainer = styled.div`
  position: absolute;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, auto); 
  grid-row-gap: 20px; 
  grid-column-gap: 20px; 
  width: 80vw; 
  height: 60vw; 
  max-width: 100%; 
  max-height: 100%; 
  left: 50%;
  top: 10vw;
  transform: translateX(-50%); 

 
  @media (max-width: 600px) {
    grid-template-columns: 1fr;
    grid-template-rows: repeat(auto-fill, minmax(100px, auto)); 
    width: 80%; 
    height: auto; 
    top: 38vw; 
  }
  @media (min-width: 600 && max-width: 1050px) {
    width: 60vw; 
    height: auto; 
    top: 11vw; 
  }
`;

export const TracksImage = styled.img`
  width: 100%; 
  height: 100%;
  object-fit: cover; 
  border-radius: 8px; 

  @media (max-width: 600px) {
    height: 100%; 
    width: 100%; 
  }
`;